import Image from 'next/image'
import Link from 'next/link'
import { Fade } from 'react-awesome-reveal'

import { PageMetaData } from '@/components/atomic/PageMetaData'
import { ButtonHierarchy } from '@/components/styleguide/Button'
import { ChatWidget } from '@/components/styleguide/ChatWidget'
import { Header } from '@/components/styleguide/Header'
import { InternalLink } from '@/components/styleguide/Link'
import { constants } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { Size } from '@/types/system'

export default function RewardsAndReferralsPage() {
  return (
    <>
      <PageMetaData
        title="Get Amazon Vouchers when you lease a car or refer a friend | LeaseLoco"
        description="Discover the great rewards available from LeaseLoco. Get Amazon Vouchers when you lease a car through us or refer a friend. Arriba!"
        pageUrl={ROUTES.rewardsAndReferralsPage.url}
      />
      <ChatWidget />
      <Header />
      <div className="white-base-layer">
        <div className="container container--body container--rewards">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-8 offset-lg-1 text-left">
              <Fade>
                <div className="background-white">
                  <h1>Loco Rewards</h1>
                  <p>
                    Hey Hombre! We take prices directly from our leasing partners and don&apos;t add
                    a penny to them, so you can be sure you&apos;re always getting the best price.
                    And as a thank you for using LeaseLoco, we&apos;ll give you £20 in Amazon
                    vouchers for each deal leased through us. Arrrriba.
                  </p>
                  <Link href={ROUTES.rewardsTermsPage.url}>Terms &amp; conditions apply.</Link>
                </div>
              </Fade>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-5 p-0">
              <div className="rewards-explainer__image-container">
                <Fade>
                  <Image
                    src={`${constants.imageHost.assets}/homepage/pinata.png`}
                    alt="a pinata"
                    width="360"
                    height="575"
                  />
                </Fade>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center">
              <div className="text-left background-white">
                <h1>Loco Referrals</h1>
                <p>
                  Want more Amazon vouchers? We&apos;ve got you covered through our Refer a Friend
                  programme. As a thank you for spreading the word on how amazing LeaseLoco is,
                  we&apos;ll give you a £20 Amazon voucher every time a friend signs up to LeaseLoco
                  using your referral code and goes on to lease a car.
                </p>
                <p>So what you waiting for? Andale, andale!</p>
                <div className="raf__button-container">
                  <InternalLink
                    href={ROUTES.referAFriendPage.url}
                    size={Size.Large}
                    hierarchy={ButtonHierarchy.Filled}
                    hasPadding
                    hasBackground>
                    Get your referral code
                  </InternalLink>
                  <InternalLink
                    href={ROUTES.rewardsPage.url}
                    size={Size.Large}
                    hierarchy={ButtonHierarchy.Bezeled}
                    hasPadding
                    hasBackground>
                    Claim your reward
                  </InternalLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
